
import { IRecord } from "../../../models"

export interface IRecordSearch {
	TotalDocumentCount: number
	Documents: IRecord[]
}

export enum ERecordSearchFilter {
	All = "All",
	BioExceptions = "BioExceptions",
	LocExceptions = "LocExceptions",
	SuspensePunches = "SuspensePunches"
}